<div class="service-plan-information">
  <app-section-header [title]="'Service Plan Information'" />
  <form class="content" (ngSubmit)="onSubmit()" [formGroup]="form">
    <div class="form-row" *ngFor="let formField of formFields; let i = index;"
      [ngClass]="{'col-12': (i === 0), 'col-4': true}">
      <form-field [formField]="formField" [form]="form"> </form-field><span> <i class="pi pi-info-circle" *ngIf="i===1">
        </i></span>
    </div>
  </form>
</div>